import ResourceService from "./resource.service";

class ZoneService extends ResourceService {
  static get resource() {
    return "zone";
  }
}

export default ZoneService;
